import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// data-controller="bridge--push-token"
export default class extends BridgeComponent {
  static component = "push-token"

  connect() {
    super.connect()
  }

  requestPermission() {
    console.log("Requesting permission for push notifications...")
    this.send('requestPermission', {}, (response) => {
      console.log("Bridge response:", response)
      if (response.data == 'granted') {
        // Reload the page to hide the "enable notifications" banner
        // Token is sent to push tokens controller in the background
        // TODO: hide the banner/link instead of reloading the page
        setTimeout(() => { window.location.reload() }, 500)
      }
    })
  }
}
